import { DISPLAY_COMMANDS } from "./assistant-catalog-display.js";
import { NAVIGATE_COMMANDS } from "./assistant-catalog-navigate.js";
import { SIMULATION_COMMANDS } from "./assistant-catalog-simulation.js";
import { INTERPRETATION_COMMANDS } from "./assistant-catalog-interpretation.js";
import { OPERATION_COMMANDS } from "./assistant-catalog-operation.js";
import { STRUCTURE_COMMANDS } from "./assistant-catalog-structure.js";
import { PARAMS_COMMANDS } from "./assistant-catalog-params.js";
import { CONFIG_COMMANDS } from "./assistant-catalog-config.js";
import { DEVICES_ADMIN_COMMANDS } from "./assistant-catalog-devices-admin.js";
import { type CommandSpec } from "./assistant-catalog-types.js";

// Re-export explícito da API pública (NÃO usa `export *` p/ não vazar helpers `Uuid`/`IsoDate`,
// que colidem com common.ts). Consumidores importam estes nomes de `@opus-dt/shared-types`.
export {
  CATALOG_VERSION,
  COMMAND_KIND_TO_PRISMA,
  RISK_TIER_TO_PRISMA,
  type CommandSpec,
  type CommandKind,
  type CommandRiskTier,
  type CommandRenderTarget,
} from "./assistant-catalog-types.js";

// Catálogo de comandos (allowlist versionada). Fonte única do que o modelo pode
// pedir. O modelo NÃO executa: devolve commands[], a plataforma valida (allowlist + args Zod +
// minRole + tier) e executa. `kind`/`riskTier`/`renderTarget` são decididos na plataforma, nunca
// pelo modelo. O dispatch (efeito no servidor) vive em apps/api/.../command-dispatch (exaustividade).
// Este arquivo é o BARREL: tipos/helpers em assistant-catalog-types.ts, comandos por família em
// assistant-catalog-<família>.ts (guardrail max-lines 200). Imports dos consumidores são estáveis.

export const COMMAND_CATALOG: readonly CommandSpec[] = [
  ...DISPLAY_COMMANDS,
  ...NAVIGATE_COMMANDS,
  ...SIMULATION_COMMANDS,
  ...INTERPRETATION_COMMANDS,
  ...OPERATION_COMMANDS,
  ...STRUCTURE_COMMANDS,
  ...PARAMS_COMMANDS,
  ...CONFIG_COMMANDS,
  ...DEVICES_ADMIN_COMMANDS,
];

const CATALOG_BY_NAME = new Map(COMMAND_CATALOG.map((c) => [c.name, c]));

export function getCommandSpec(name: string): CommandSpec | undefined {
  return CATALOG_BY_NAME.get(name);
}

// O manifesto (projeção do catálogo para o modelo) vive em assistant-catalog-manifest.ts.
